import { Box } from "@nulogy/components";
import React from "react";

export default function StickyFooter({ children }) {
  // First box is to space out height behind footer
  return (
    <>
      <Box height="x6" />
      <Box
        backgroundColor="white"
        bottom={0}
        boxShadow="0px -3px 5px 0px rgba(1, 30, 56, 0.1)"
        className="ps-sticky-footer"
        left={0}
        paddingLeft="x2"
        paddingTop="x2"
        position="fixed"
        width="100%"
        // content (100) clears a table's sticky header and cells (10), which would otherwise scroll over
        // the footer, and stays under notifications (999).
        zIndex="content"
      >
        {children}
      </Box>
    </>
  );
}
